import type { ReactNode } from "react";
import styled from "styled-components";
import { DonutSegment } from "./DonutSegment";

type SegmentData = {
  percentage: number;
  color?: string;
};

type Props = {
  children: ReactNode;
  segments: SegmentData[];
  donutWidth?: number;
  donutHeight?: number;
  strokeWidth?: number;
  circleSizeX?: number;
  circleSizeY?: number;
};

export function Donut({
  children,
  segments,
  donutWidth,
  donutHeight,
  strokeWidth = 2.6,
  circleSizeX = 224,
  circleSizeY = 224,
}: Props) {
  const calculateOffset = (index: number) =>
    segments.reduce((prev, curr, segmentIndex) => {
      if (segmentIndex >= index) {
        return prev;
      }

      return prev + curr.percentage;
    }, 0);

  return (
    <CircleContainer
      style={{ width: donutWidth ?? 224, height: donutHeight ?? 224 }}
    >
      <svg viewBox={"0 0 42 42"} width={circleSizeX} height={circleSizeY}>
        <circle
          className={"donut-hole"}
          cx={"21"}
          cy={"21"}
          r={"15.91549430918954"}
          fill={"#FFFFFF"}
          opacity={"0.5"}
        />
        <circle
          className={"donut-ring"}
          cx={"21"}
          cy={"21"}
          r={"15.91549430918954"}
          fill={"transparent"}
          stroke={segments.length > 0 ? "white" : "gray"}
          strokeWidth={strokeWidth}
        />
        {segments.map((segment, index) => (
          <DonutSegment
            key={`segment-${index}`}
            color={segment.color}
            percentage={segment.percentage}
            offset={index === 0 ? undefined : calculateOffset(index)}
            isFirst={index === 0}
            strokeWidth={strokeWidth}
          />
        ))}
      </svg>
      <AbsoluteWrapper>{children}</AbsoluteWrapper>
    </CircleContainer>
  );
}

const CircleContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  text-align: center;
  font-weight: bold;
  width: 100%;
  svg {
    transform: rotate(-90deg);
  }
`;

const AbsoluteWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
